import { Component } from '@angular/core';

@Component({
    selector: 'mapp-new-chat-button',
    templateUrl: './new-chat-button.component.html',
    styleUrls: ['./new-chat-button.component.scss'],
    standalone: false,
})
export class NewChatButtonComponent {}
